/// <reference path="./helpers.d.ts" />
import { GUtil } from '../gutil';
import { PageGen, PdfUnit, ETextAlign } from '../pdf';
import { PdfPen, PdfBrush, PdfRect, PdfPoint, PdfColor, PdfFont } from '../pdf';

/**
 * Draw a light gray background fill.
 * Port of C# G<T>.DrawBackground()
 */
PageGen.prototype.drawBackground = function (rect: PdfRect): void {
  this.drawRectangle(null, GUtil.backgroundBrush, rect);
};

/**
 * Draw centered text with optional background.
 * Port of C# G<T>.DrawFillStringCenter()
 */
PageGen.prototype.drawFillStringCenter = function (
  text: string,
  font: PdfFont,
  brush: PdfBrush,
  rect: PdfRect,
  background = false
): void {
  if (!text) return;

  if (background) {
    this.drawBackground(rect);
  }

  const f = this.adjustFont(rect.width * 0.95, [text], font);
  this.drawString(text, f, brush, null, rect, ETextAlign.Center);
};

/**
 * Draw a finish line pattern (checkered).
 * Port of C# DrawRectFinish()
 */
PageGen.prototype.drawRectFinish = function (rect: PdfRect): void {
  const squareSize = PdfUnit.FromMillimeters(3);
  const cols = Math.ceil(rect.width / squareSize);
  const rows = Math.ceil(rect.height / squareSize);
  const blackBrush = PdfBrush.Black;
  const whiteBrush = new PdfBrush(PdfColor.fromRgb(255, 255, 255));

  for (let row = 0; row < rows; row++) {
    for (let col = 0; col < cols; col++) {
      const isBlack = (row + col) % 2 === 0;
      const x = rect.x + col * squareSize;
      const y = rect.y + row * squareSize;
      const w = Math.min(squareSize, rect.right - x);
      const h = Math.min(squareSize, rect.bottom - y);

      if (w > 0 && h > 0) {
        this.drawRectangle(null, isBlack ? blackBrush : whiteBrush, new PdfRect(x, y, w, h));
      }
    }
  }

  this.drawRectangle(GUtil.basePen, null, rect);
};

/**
 * Convert normalized {x, y} points (0-1 range) to PdfPoint array scaled to rect.
 */
PageGen.prototype.toPdfPoints = function (
  pts: { x: number; y: number }[],
  rect: PdfRect
): PdfPoint[] {
  return pts.map((p) => new PdfPoint(rect.x + rect.width * p.x, rect.y + rect.height * p.y));
};
